import React, { useEffect, useState, useContext } from "react";
import { Modal } from "react-bootstrap";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import ButtonCustom from "../../../components/buttons/ButtonCustom";
import ButtonSaveCustom from "../../../components/buttons/SaveButton";
import blogFetch from "../../../axios/config";
import { getIdCompany } from "../../../utils/constantes";
import RegisterEquipment from "./RegisterEquipment";
import { IEquipment } from "./equipmentInterfaces";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import Context from "../../../context/Context";
import language from "../../../nls/language.json";

function Equipment() {
  const [equipments, setEquipments] = useState<IEquipment[]>();
  const [showModalAdd, setShowModalAdd] = useState(false);
  const [showModalDelete, setShowModalDelete] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [equipmentId, setEquipmentId] = useState<number>(0);
  const [loading, setLoading] = useState(false);
  const [hoveredRow, setHoveredRow] = useState<number | null>(null);
  const { useRef } = React;
  const ref = React.useRef<any>(null);
  const styleCell = {padding:1.5};

  const {
    getStatusSideBar,
    selectedCountry
  } = useContext(Context)

  useEffect(() => {
    getEquipments();
  }, []);

  const getEquipments = async () => {
    try {
      let response = await blogFetch.get(
        `/equipment?companyId=${getIdCompany()}`
      );
      let data = response.data;
      setEquipments(data);
    } catch (error) {
      console.error(error);
    }
  };

  const deleteEquipment = async (id: number) => {
    try {
      await blogFetch.delete(`/question/${id}`);
      getEquipments();
    } catch (error) {
      console.error(error);
    }
  };
  
  const modalAdd = () => {
    return (
      <Modal show={showModalAdd} onHide={() => setShowModalAdd(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {(language as Record<string, any>)[selectedCountry.name].Cadastro.equipamento.modal.adicionar.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <RegisterEquipment ref={ref}></RegisterEquipment>
        </Modal.Body>
        <Modal.Footer>
          <ButtonCustom
            typeButton="text"
            sx={{ marginRight: 2 }}
            onClick={() => setShowModalAdd(false)}
          >
            {(language as Record<string, any>)[selectedCountry.name].Cadastro.equipamento.modal.adicionar.btnCancelar}
          </ButtonCustom>
          <ButtonSaveCustom
            loading={loading}
            typeButton="contained"
            onClick={async () => {
              setLoading(true);
              try {
                await ref.current.addEquipment();
                setLoading(false);
                setShowModalAdd(false);
                getEquipments();
              } catch (error) {
                console.error();
                setLoading(false);
              }
            }}
          >
            {(language as Record<string, any>)[selectedCountry.name].Cadastro.equipamento.modal.adicionar.btnSalvar}
          </ButtonSaveCustom>
        </Modal.Footer>
      </Modal>
    );
  };

  const modalEdit = () => {
    return (
      <Modal show={showModalEdit} onHide={() => setShowModalEdit(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{(language as Record<string, any>)[selectedCountry.name].Cadastro.equipamento.modal.editar.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <RegisterEquipment
            ref={ref}
            idEquipment={equipmentId}
          ></RegisterEquipment>
        </Modal.Body>{" "}
        <Modal.Footer>
          <ButtonCustom
            typeButton="text"
            sx={{ marginRight: 2 }}
            onClick={() => setShowModalEdit(false)}
          >
            {(language as Record<string, any>)[selectedCountry.name].Cadastro.equipamento.modal.adicionar.btnCancelar}
          </ButtonCustom>
          <ButtonSaveCustom
            loading={loading}
            typeButton="contained"
            onClick={async () => {
              setLoading(true);
              try {
                await ref.current.updateEquipment();
                setLoading(false);
                setShowModalEdit(false);
                getEquipments();
              } catch (error) {
                console.error();
                setLoading(false);
              }
            }}
          >
            {(language as Record<string, any>)[selectedCountry.name].Cadastro.equipamento.modal.adicionar.btnSalvar}
          </ButtonSaveCustom>
        </Modal.Footer>
      </Modal>
    );
  };

  const modalDelete = () => {
    return (
      <Modal show={showModalDelete} onHide={() => setShowModalDelete(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{(language as Record<string, any>)[selectedCountry.name].Cadastro.equipamento.modal.deletar.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body ref={ref}>
         {(language as Record<string, any>)[selectedCountry.name].Cadastro.equipamento.modal.deletar.corpoModal}
        </Modal.Body>
        <Modal.Footer>
          <ButtonCustom
            typeButton="text"
            sx={{ marginRight: 2 }}
            onClick={() => setShowModalDelete(false)}
          >
            {(language as Record<string, any>)[selectedCountry.name].Cadastro.equipamento.modal.deletar.btnCancelar}
          </ButtonCustom>
          <ButtonSaveCustom
            loading={loading}
            typeButton="contained"
            onClick={async () => {
              setLoading(true);
              try {
                deleteEquipment(equipmentId);
                setLoading(false);
                setShowModalDelete(false);
                getEquipments();
              } catch (error) {
                console.error();
                setLoading(false);
              }
            }}
          >
            {(language as Record<string, any>)[selectedCountry.name].Cadastro.equipamento.modal.deletar.btnSalvar}
          </ButtonSaveCustom>
        </Modal.Footer>
      </Modal>
    );
  };

  return (
    <>
      <div className={`app_body ${getStatusSideBar()}`}>
        <div className="header_tables_view">
          <div></div>
          <div>
            <h3 className="title_tables">
              {(language as Record<string, any>)[selectedCountry.name].Cadastro.equipamento.title}
            </h3>
          </div>
          <div>
            <ButtonCustom
              typeButton="contained"
              onClick={() => setShowModalAdd(true)}
            >
              {(language as Record<string, any>)[selectedCountry.name].Cadastro.equipamento.btnAdicionar}
            </ButtonCustom>
          </div>
        </div>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow className="table-header">
              <TableCell>#</TableCell>
              <TableCell>{(language as Record<string, any>)[selectedCountry.name].Cadastro.equipamento.tableHeader.descricao}</TableCell>
              <TableCell>{(language as Record<string, any>)[selectedCountry.name].Cadastro.equipamento.tableHeader.fabricante}</TableCell>
              <TableCell align="right">{(language as Record<string, any>)[selectedCountry.name].Cadastro.equipamento.tableHeader.editar}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!!equipments &&
              equipments.map((item, index) => (
                <TableRow
                  key={item.eqP_PK_idEquipment}
                  onMouseEnter={() =>
                    setHoveredRow(
                      item.eqP_PK_idEquipment == undefined
                        ? null
                        : item.eqP_PK_idEquipment
                    )
                  }
                  onMouseLeave={() => setHoveredRow(null)}
                  style={{
                    cursor: "pointer",
                    backgroundColor:
                      hoveredRow === item.eqP_PK_idEquipment
                        ? "#F5F5F5"
                        : "transparent",
                  }}
                >
                  <TableCell sx={styleCell}>
                    {item.eqP_PK_idEquipment}
                  </TableCell>
                  <TableCell sx={styleCell}>{item.eqP_description}</TableCell>
                  <TableCell sx={styleCell}>
                    {item.manufacturer?.mfC_name}
                  </TableCell>
                  <TableCell sx={styleCell} align="right">
                    <ModeEditIcon
                      onClick={() => {
                        setEquipmentId(item.eqP_PK_idEquipment);
                        setShowModalEdit(true);
                      }}
                    />
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </div>

      {modalAdd()}
      {modalDelete()}
      {modalEdit()}
    </>
  );
}

export default Equipment;
